import { PriceSortQueryValue } from '../../types/searchState';
import { AlgoliaIndiceName } from '../../constants/algolia';
import { DeviceType } from '../../types/deviceType';

export const getAlgoliaIndice = (
  deviceType: DeviceType,
  sort: PriceSortQueryValue,
  indice: AlgoliaIndiceName,
  sortingIndex: string | null = null,
) => {
  if (sort === PriceSortQueryValue.ASC) {
    return AlgoliaIndiceName.PRODUCTS_PRICE_ASC;
  }
  if (sort === PriceSortQueryValue.DESC) {
    return AlgoliaIndiceName.PRODUCTS_PRICE_DESC;
  }
  if (sortingIndex && sortingIndex !== 'default') {
    return [AlgoliaIndiceName.PRODUCTS, deviceType === DeviceType.mobile ? 'mobile' : null, sortingIndex]
      .filter((item) => item !== null)
      .join('_') as AlgoliaIndiceName;
  }
  if (indice === AlgoliaIndiceName.PRODUCTS) {
    return deviceType === DeviceType.desktop ? indice : AlgoliaIndiceName.PRODUCTS_MOBILE;
  }
  return indice;
};
